import React from "react";

import Tag from "antd/es/tag";

import { Person } from "@mapmycustomers/shared/types/entity";
import { Avatar } from "@mapmycustomers/ui";

import PersonName from "@app/component/person/PersonName";
import UserPreviewCard from "@app/component/UserPreviewCard";
import { formatRawDate } from "@app/util/formatters";

import styles from "../EntityListModal.module.scss";

import { ColumnsFactory } from "./ColumnsFactory";

export const createPersonListColumns: ColumnsFactory<Person> = (intl) => [
  {
    dataIndex: "person",
    key: "person",
    render: (ignore: any, person: Person) => <PersonName person={person} />,
    title: intl.formatMessage({
      id: "reports.overview.peopleList.column.person",
      defaultMessage: "Person",
      description: "Title of a Person column in People table on People Modal on Overview page",
    }),
  },
  {
    className: styles.secondaryCol,
    dataIndex: "address",
    key: "address",
    title: intl.formatMessage({
      id: "reports.overview.peopleList.column.address",
      defaultMessage: "Address",
      description: "Title of a Address column in People table on People Modal on Overview page",
    }),
  },
  {
    dataIndex: "createdAt",
    key: "createdAt",
    render: (createdAt: Person["createdAt"]) => <Tag>{formatRawDate(createdAt, "PPPpp")}</Tag>,
    title: intl.formatMessage({
      id: "reports.overview.peopleList.column.createdAt",
      defaultMessage: "Created at",
      description: "Title of a Created at column in People table on People Modal on Overview page",
    }),
  },
  {
    dataIndex: "user",
    key: "user",
    render: (user: Person["user"]) => (
      <UserPreviewCard userId={user.id}>
        <Avatar actionOnHover user={user} />
      </UserPreviewCard>
    ),
    title: intl.formatMessage({
      id: "reports.overview.peopleList.column.owner",
      defaultMessage: "Owner",
      description: "Title of a Owner column in People table on People Modal on Overview page",
    }),
    width: "15%",
  },
];
